/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
define(['./geopolViewService'], function(GeopolViewService) {
    'use strict';
    return new GeopolViewService();
});



// WEBPACK FOOTER //
// ./config/geopolView/globalGeopolViewService.js